var STAR_SVG_TYPE = {
  EMPTY: 'starrating-empty',
  EMPTY_HOVERED: 'starrating-empty-hovered',
  HALF: 'starrating-half',
  FULL: 'starrating-full'
};
export default STAR_SVG_TYPE;